import { Pipe, PipeTransform } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { AbstractAuthorizationService } from "../authorization/services/abstractAuthorization.service";
import { IStepInit, Step } from "../interfaces";
import { LogClass, Logger } from "../logger";
import { CirculationFacade } from "../services/circulation.facade";
import { selectCurrentUser } from "../user/state";

// https://dzone.com/articles/why-we-shound-not-use-function-inside-angular-temp

@Pipe({
    name: "canEditStep",
    pure: true,
    standalone: false
})
@LogClass({ source: "CanEditStepPipe" })
export class CanEditStepPipe implements PipeTransform {
  private logger: Logger;

  constructor(
    private store: Store,
    private circulationFacade: CirculationFacade,
    private authorizationService: AbstractAuthorizationService
  ) {
    this.logger.debug("ctor");
  }

  public transform(value: Step | IStepInit): Observable<boolean> {
    if (!value) {
      return of(false);
    }
    if (value instanceof Step) {
      return this.store
        .select(selectCurrentUser)
        .pipe(
          switchMap((user) =>
            value.canEdit(
              user,
              this.circulationFacade,
              this.authorizationService.isAdmin(user.roles)
            )
          )
        );
    }

    const tmp = new Step(value);
    return this.transform(tmp);
  }
}
